<template lang="html">
  <div class="about">
    <div class="about-cover">
      <video autoplay muted loop playsinline poster="/static/video/about.jpg">
        <source src="/static/video/about.mp4" type="video/mp4"/>
      </video>
    </div>
    <div class="about-content">
      <p>Наша главная задача&nbsp;&mdash; сделать процесс закупки для клиента проще и&nbsp;удобнее. Поэтому мы&nbsp;работаем только с&nbsp;проектами полной комплектации интерьеров.</p>
      <p>Мы&nbsp;работаем с&nbsp;<router-link to="/companies">фабриками-производителями</router-link> много лет: со&nbsp;многими знакомы лично, а&nbsp;с&nbsp;кем-то давно дружим. Это позволяет нам получить наиболее выгодные условия.</p>
      <p>Не&nbsp;важно: итальянский шик или скандинавский минимализм. Мы&nbsp;подбираем и&nbsp;привозим мебель и&nbsp;предметы декора для всех типов интерьеров.</p>
      <p>Наш шоурум с&nbsp;постоянной экспозицией и&nbsp;богатой библиотекой образцов находится в&nbsp;самом центре Петербурга. <router-link to="/contact">Приходите в&nbsp;гости</router-link>.</p>

      <AboutA/>

      <p>Вы&nbsp;наверное спросите про название&hellip; 1.618&nbsp;&mdash; это &laquo;золотое число&raquo;, которое получается при расчете математической формулы того самого золотого сечения. Для нас золотое сечение&nbsp;&mdash; символ гармоничного сочетания всех элементов интерьера. Это принцип, которого мы&nbsp;всегда придерживаемся в&nbsp;своей работе.</p>
      <p>Пространство шоурума совмещает демонстрационную и&nbsp;рабочую зоны. В&nbsp;демонстрационной части представлена композиция из&nbsp;мебели и&nbsp;декоративных предметов от&nbsp;фабрик и&nbsp;брендов, с&nbsp;которыми мы&nbsp;работаем.</p>

      <AboutB/>

      <p>Рабочее пространство&nbsp;&mdash; это место, где создается будущий интерьер. В&nbsp;процессе неформального общения с&nbsp;заказчиком наши дизайнеры собирают коллажи и&nbsp;конструируют детальный образ интерьера. Творческий процесс, участником которого являетесь и&nbsp;вы, происходит за&nbsp;интерактивной стойкой, а&nbsp;визуализация транслируется на&nbsp;большом экране, позволяя сразу&nbsp;же оценить, как отобранные предметы и&nbsp;материалы проявляются в&nbsp;архитектурном пространстве.</p>

      <AboutC/>

      <p>Большую часть шоурума занимает коллекция образцов тканей, дерева, керамики и&nbsp;камня, которое дает возможность не&nbsp;только вживую увидеть составные элементы будущего интерьера, но&nbsp;и, что часто более важно,&nbsp;&mdash; потрогать и&nbsp;почувствовать материал.</p>

    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VueRouter from 'vue-router'
import AboutA from '@/components/svgs/AboutA'
import AboutB from '@/components/svgs/AboutB'
import AboutC from '@/components/svgs/AboutC'


Vue.use(VueRouter)

export default {
  name: 'About',
  components: {
    AboutA,
    AboutB,
    AboutC
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/settings';
@import '../scss/mixins';

.about {
  padding-top: 100px;
  @include stickyFooter();
  @include container();
}

.about-content {
  padding: 16px $padding;
  img {
    width: 100%;
    padding-top: $padding;
    padding-bottom: $padding / 2;
  }
}

.about-cover {
  padding-bottom: 100%;
  position: relative;
  video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}

.about-map {
  opacity: 0.4;
}

</style>



// WEBPACK FOOTER //
// src/components/About.vue